import { useState } from 'react';
import { Smartphone } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { useInstallContext } from '@/lib/installContext';
import { InstallInstructions } from '@/components/install/InstallInstructions';
import { Link } from 'react-router-dom';

export function InstallAppButton({ className = '', variant = 'sidebar' }) {
  const ctx = useInstallContext();
  const [open, setOpen] = useState(false);
  if (ctx.standalone) return null;

  const base = variant === 'profile'
    ? 'w-full h-12 rounded-md border border-[#FFD700]/40 text-[#FFD700] hover:bg-[#FFD700]/10 flex items-center justify-center gap-2 text-sm font-medium transition-colors'
    : 'w-full justify-start flex items-center px-4 py-2 rounded-md text-sm transition-colors';

  return (
    <>
      <button onClick={() => setOpen(true)} className={`${base} ${className}`} data-testid="install-app-btn">
        <Smartphone className="w-4 h-4 mr-2" /> Installer l’application
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#18181B] border-[#FFD700]/30 text-white max-w-sm" data-testid="install-app-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-white"><img src="/icons/icon-192.png" alt="" className="w-7 h-7 rounded-lg" /> Installer MboaSend</DialogTitle>
            <DialogDescription className="text-[#A1A1AA] text-xs">Navigateur détecté : {ctx.browserLabel}</DialogDescription>
          </DialogHeader>
          <InstallInstructions ctx={ctx} onInstalled={() => setOpen(false)} />
          <Link to="/installer" onClick={() => setOpen(false)} className="text-[11px] text-[#FFD700]/80 underline underline-offset-2" data-testid="install-app-guide-link">Voir le guide complet</Link>
        </DialogContent>
      </Dialog>
    </>
  );
}
